import { render, staticRenderFns } from "./AdminContent.vue?vue&type=template&id=60c1dedc"
import script from "./AdminContent.vue?vue&type=script&lang=js"
export * from "./AdminContent.vue?vue&type=script&lang=js"
import style0 from "./AdminContent.vue?vue&type=style&index=0&id=60c1dedc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports